import React, { Fragment } from 'react'
import ReplyItem from 'flow/siteProposal/components/comments/replyItem/replyItem'
import { ReplySectionContainer, BottomSeparator } from './style'
import ReplyForm from 'flow/siteProposal/components/comments/replyForm/index'

const RepliesList = ({commentData, getReplyData, replyState, setReplyState, replyText, commentId, getCommentsData}) => {
  const sortData = commentData.sort((a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt))
  const repliesList = sortData.map((reply, index) => {
    const profile = {
      firstName: reply.User.firstName,
      lastName: reply.User.lastName,
      roleId: reply.User.Role.id,
      organisation: reply.User.Role.name,
      Role: {
        name: reply.User.Role.name
      }
    }

    return (
      <Fragment key={reply.id}>
        <ReplyItem
          text={reply.content}
          createdAt={reply.createdAt}
          updatedAt={reply.updatedAt}
          profile={profile}
          commentId={reply.id}
          getReplyData={getReplyData}
        />
        {index < sortData.length - 1 && <BottomSeparator><hr/></BottomSeparator>}
      </Fragment>
    )
  }
  )

  return (
    <ReplySectionContainer>
      {replyState === 'add' ? <ReplyForm getReplyData={getReplyData} setReplyState={setReplyState} commentId={commentId} replyText={replyText} getCommentsData={getCommentsData} /> : ''}
      {repliesList}
    </ReplySectionContainer>
  )
}

export default RepliesList
